import Radio from 'backbone.radio';

const fileChannel = Radio.channel( 'file' );

export default class FileUtility {
	parse( file ) {
		const reader = new FileReader();

		reader.onload = e => {
			let file_base64 = e.target.result;
			fileChannel.trigger( 'file:parse', file_base64 );
		};

		reader.readAsDataURL( file );
		this.file = file;

		return this;
	}
}